/*
 * WWFS cart pricing — R20
 * Old Enterprise + Wholesale All In One
 *
 * Replace: assets/wwfs-cart-drawer.js
 */
(function () {
  'use strict';

  var SELECTORS = {
    drawer: 'cart-drawer',
    cartPage: '#cart',
    summary: '[data-wwfs-cart-pricing], [data-wwfs-main-summary]',
    state: '[data-wwfs-cart-state]',
    savingRow: '[data-wwfs-saving-row]',
    savingLabel: '[data-wwfs-saving-label]',
    savingOutput: '[data-wwfs-saving-output]',
    beforeOutput: '[data-wwfs-before-output]',
    finalOutput: '[data-wwfs-final-output]',
    appTotal: '[data-wwfs-app-total-source]',
    line: '.cart-item[data-wwfs-regular-line-total]',
    lineCurrent: '.cart-item__total .price__current',
    lineWas: '.cart-item__total .price__was'
  };

  /*
   * Enterprise renders the add response after 700 ms. The background refresh
   * must run after that render so stale add-response markup cannot overwrite
   * Wholesale's completed prices.
   */
  var OUTSIDE_ADD_RENDER_WAIT = 850;
  var WHOLESALE_READY_MAX = 2500;
  var WHOLESALE_READY_STEP = 50;
  var PRICE_IDLE_TIME = 280;
  var NO_CHANGE_GRACE = 2800;
  var TRANSACTION_MAX = 6000;

  var framePending = false;
  var transaction = null;
  var transactionNumber = 0;
  var outsideAddTimer = null;
  var wholesaleReadyTimer = null;

  function sampleLimitSummary(element) {
    var summary = element && element.closest(
      '[data-wwfs-cart-pricing], [data-wwfs-main-summary]'
    );

    if (summary) {
      return summary;
    }

    var formId = element && element.getAttribute && element.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;

    return form && form.closest(
      '[data-wwfs-cart-pricing], [data-wwfs-main-summary]'
    );
  }

  function signedInSampleLimitExceeded(summary) {
    return Boolean(
      summary &&
      document.body.getAttribute('data-wwfs-customer-logged-in') === 'true' &&
      summary.getAttribute('data-wwfs-sample-limit-exceeded') === 'true'
    );
  }

  function showSampleLimit(summary) {
    var alert = summary && summary.querySelector(
      '[data-wwfs-sample-limit-alert]'
    );

    if (!alert) {
      return;
    }

    alert.hidden = false;
    alert.focus({ preventScroll: true });
    alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function stopOverLimitCheckout(event, summary) {
    if (!signedInSampleLimitExceeded(summary)) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();
    showSampleLimit(summary);
    return true;
  }

  if (!window.WWFSSampleLimitGuard) {
    window.WWFSSampleLimitGuard = true;

    document.addEventListener('click', function (event) {
      var checkout = event.target.closest('[data-wwfs-standard-checkout]');

      if (checkout) {
        stopOverLimitCheckout(event, sampleLimitSummary(checkout));
      }
    }, true);

    document.addEventListener('submit', function (event) {
      stopOverLimitCheckout(event, sampleLimitSummary(event.target));
    }, true);
  }

  if (window.WWFSCartPricing) {
    window.WWFSCartPricing.refresh();
    return;
  }

  function moneyValues(text) {
    var matches = String(text || '').match(
      /(?:£\s*[\d,]+(?:\.\d{1,2})?|GBP\s*[\d,]+(?:\.\d{1,2})?|[\d,]+(?:\.\d{1,2})?\s*GBP)/gi
    ) || [];

    return matches.map(function (match) {
      var value = parseFloat(match.replace(/[^0-9.]/g, ''));
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    }).filter(function (value) {
      return value !== null;
    });
  }

  function firstMoney(text) {
    var values = moneyValues(text);
    return values.length ? values[0] : null;
  }

  function formatMoney(cents) {
    var currency = (
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
    ) || 'GBP';

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function setText(element, text) {
    if (element && element.textContent.trim() !== text) {
      element.textContent = text;
    }
  }

  function scopeFor(element) {
    return element && element.closest(SELECTORS.drawer)
      ? 'drawer'
      : 'cart';
  }

  function summaryFor(scope) {
    return document.querySelector(
      scope === 'drawer'
        ? SELECTORS.drawer + ' [data-wwfs-cart-pricing]'
        : SELECTORS.cartPage + ' [data-wwfs-main-summary]'
    );
  }

  function lineData(summary) {
    var root = summary && summary.closest(
      SELECTORS.drawer + ', ' + SELECTORS.cartPage
    );

    if (!root) {
      return null;
    }

    var rows = root.querySelectorAll(SELECTORS.line);

    if (!rows.length) {
      return null;
    }

    var total = 0;
    var signature = [];

    for (var index = 0; index < rows.length; index += 1) {
      var current = rows[index].querySelector(SELECTORS.lineCurrent);
      var value = firstMoney(current ? current.textContent : '');

      if (!Number.isFinite(value)) {
        return null;
      }

      total += value;
      signature.push(
        (rows[index].getAttribute('data-variant-id') || index) +
        ':' +
        value
      );
    }

    return {
      total: total,
      signature: signature.join('|')
    };
  }

  function finalTotal(summary, liquidTotal, lines) {
    if (lines && Number.isFinite(lines.total)) {
      return lines.total;
    }

    var candidates = [];

    summary.querySelectorAll(SELECTORS.appTotal).forEach(function (source) {
      candidates = candidates.concat(moneyValues(source.textContent));
    });

    candidates = candidates.filter(function (value) {
      return value > 0 && value <= liquidTotal;
    });

    return candidates.length
      ? Math.min.apply(null, candidates)
      : liquidTotal;
  }

  function displayPending(scope) {
    var summary = summaryFor(scope);

    if (!summary) {
      return;
    }

    var row = summary.querySelector(SELECTORS.savingRow);

    if (row) {
      row.hidden = false;
    }

    setText(
      summary.querySelector(SELECTORS.savingLabel),
      'Applying discounts…'
    );
    setText(summary.querySelector(SELECTORS.savingOutput), '—');
  }

  function restoreLineComparison(row) {
    var regular = parseInt(
      row.getAttribute('data-wwfs-regular-line-total'),
      10
    );
    var quantityElement = row.querySelector(
      'input[name="updates[]"], .qty-input__input'
    );
    var quantity = quantityElement
      ? parseInt(quantityElement.value, 10)
      : 1;
    var totalCell = row.querySelector('.cart-item__total');
    var currentElement = totalCell
      ? totalCell.querySelector('.price__current')
      : null;
    var current = firstMoney(
      currentElement ? currentElement.textContent : ''
    );

    if (
      !Number.isFinite(regular) ||
      !Number.isFinite(current) ||
      !totalCell
    ) {
      return;
    }

    var restored = totalCell.querySelector(
      '[data-wwfs-restored-line-was]'
    );
    var nativeWasElements = totalCell.querySelectorAll(
      '.price__was:not([data-wwfs-restored-line-was])'
    );

    /*
     * Show the right-hand comparison at every valid quantity whenever the
     * stored regular line total is higher than the current line total.
     */
    if (!Number.isFinite(quantity) || quantity < 1 || regular <= current) {
      if (restored) {
        restored.remove();
      }

      nativeWasElements.forEach(function (element) {
        if (element.hasAttribute('data-wwfs-native-line-was-hidden')) {
          element.hidden = false;
          element.removeAttribute('data-wwfs-native-line-was-hidden');
        }
      });

      return;
    }

    /*
     * Enterprise briefly supplies a valid comparison price, then Wholesale
     * rewrites it as an empty but visually "visible" .price__was element.
     * Use the stable WWFS value as the sole right-hand line comparison for
     * every valid quantity, and suppress every unstable native/app copy.
     */
    nativeWasElements.forEach(function (element) {
      element.hidden = true;
      element.setAttribute('data-wwfs-native-line-was-hidden', '');
    });

    if (regular > current) {
      if (!restored) {
        restored = document.createElement('s');
        restored.className = 'price__was';
        restored.setAttribute('data-wwfs-restored-line-was', '');
      }
      restored.hidden = false;

      /*
       * Keep the restored regular line total with the right-hand current
       * total. Appending it to the cart cell places it beneath the quantity
       * controls in old Enterprise's grid.
       */
      currentElement.insertAdjacentElement('afterend', restored);
      setText(restored, formatMoney(regular));
    } else if (restored) {
      restored.remove();
    }
  }

  function updateSummary(summary) {
    var state = summary.querySelector(SELECTORS.state);

    if (!state) {
      return;
    }

    var before = parseInt(
      state.getAttribute('data-wwfs-before-total'),
      10
    );
    var liquid = parseInt(
      state.getAttribute('data-wwfs-liquid-total'),
      10
    );

    if (!Number.isFinite(before) || !Number.isFinite(liquid)) {
      return;
    }

    var lines = lineData(summary);
    var total = finalTotal(summary, liquid, lines);
    var saving = Math.max(0, before - total);
    var scope = scopeFor(summary);
    var isPending = transaction && transaction.scope === scope;

    setText(
      summary.querySelector(SELECTORS.beforeOutput),
      formatMoney(before)
    );
    setText(
      summary.querySelector(SELECTORS.finalOutput),
      formatMoney(total)
    );

    if (isPending) {
      displayPending(scope);
      notePriceSignature(lines ? lines.signature : String(total));
    } else {
      var savingRow = summary.querySelector(SELECTORS.savingRow);

      if (savingRow) {
        savingRow.hidden = saving <= 0;
      }

      setText(
        summary.querySelector(SELECTORS.savingLabel),
        'Discounts applied'
      );
      setText(
        summary.querySelector(SELECTORS.savingOutput),
        '−' + formatMoney(saving)
      );
    }
  }

  function refreshNow() {
    document.querySelectorAll(SELECTORS.summary).forEach(updateSummary);
    document.querySelectorAll(SELECTORS.line).forEach(restoreLineComparison);
  }

  function refresh() {
    if (framePending) {
      return;
    }

    framePending = true;

    window.requestAnimationFrame(function () {
      framePending = false;
      refreshNow();
    });
  }

  function clearTransactionTimers(cycle) {
    if (!cycle) {
      return;
    }

    window.clearTimeout(cycle.idleTimer);
    window.clearTimeout(cycle.noChangeTimer);
    window.clearTimeout(cycle.maxTimer);
  }

  function finishTransaction(id) {
    if (!transaction || transaction.id !== id) {
      return;
    }

    clearTransactionTimers(transaction);
    transaction = null;
    refresh();
  }

  function notePriceSignature(signature) {
    if (!transaction || !transaction.wholesaleStarted) {
      return;
    }

    if (signature === transaction.signature) {
      return;
    }

    transaction.signature = signature;
    transaction.sawPriceChange = true;
    window.clearTimeout(transaction.idleTimer);

    var id = transaction.id;

    transaction.idleTimer = window.setTimeout(function () {
      finishTransaction(id);
    }, PRICE_IDLE_TIME);
  }

  function beginTransaction(scope) {
    if (transaction) {
      clearTransactionTimers(transaction);
    }

    transactionNumber += 1;

    transaction = {
      id: transactionNumber,
      scope: scope,
      signature: '',
      sawPriceChange: false,
      wholesaleStarted: false,
      idleTimer: null,
      noChangeTimer: null,
      maxTimer: null
    };

    var id = transaction.id;

    transaction.maxTimer = window.setTimeout(function () {
      finishTransaction(id);
    }, TRANSACTION_MAX);

    displayPending(scope);
    refresh();

    return id;
  }

  function wholesaleFunction(scope) {
    if (!window.WSAIO) {
      return null;
    }

    if (
      scope === 'cart' &&
      typeof window.WSAIO.cartPage === 'function'
    ) {
      return window.WSAIO.cartPage;
    }

    return typeof window.WSAIO.cartDrawer === 'function'
      ? window.WSAIO.cartDrawer
      : null;
  }

  function startWholesale(id) {
    if (!transaction || transaction.id !== id) {
      return;
    }

    transaction.wholesaleStarted = false;
    refreshNow();

    var summary = summaryFor(transaction.scope);
    var lines = lineData(summary);

    transaction.signature = lines
      ? lines.signature
      : summary
        ? summary.textContent.replace(/\s+/g, ' ').trim()
        : '';
    transaction.wholesaleStarted = true;

    try {
      wholesaleFunction(transaction.scope).call(window.WSAIO, 0);
    } catch (error) {
      console.warn('WWFS: Wholesale cart calculation failed.', error);
      finishTransaction(id);
      return;
    }

    transaction.noChangeTimer = window.setTimeout(function () {
      finishTransaction(id);
    }, NO_CHANGE_GRACE);
  }

  function waitForWholesale(id, startedAt) {
    if (!transaction || transaction.id !== id) {
      return;
    }

    if (wholesaleFunction(transaction.scope)) {
      startWholesale(id);
      return;
    }

    if (Date.now() - startedAt >= WHOLESALE_READY_MAX) {
      /*
       * Retail carts without the app, or pages where it failed to load,
       * must remain fully usable. Shopify/Liquid prices are still valid.
       */
      finishTransaction(id);
      return;
    }

    wholesaleReadyTimer = window.setTimeout(function () {
      waitForWholesale(id, startedAt);
    }, WHOLESALE_READY_STEP);
  }

  function runWholesale(id) {
    window.clearTimeout(wholesaleReadyTimer);
    waitForWholesale(id, Date.now());
  }

  async function refreshClosedDrawer(id) {
    var drawer = document.querySelector(SELECTORS.drawer);

    if (
      !transaction ||
      transaction.id !== id ||
      !drawer ||
      typeof drawer.refresh !== 'function'
    ) {
      finishTransaction(id);
      return;
    }

    try {
      /*
       * true forces Enterprise to fetch and render the complete drawer
       * section. Its native renderContents(..., false) keeps it closed.
       */
      await drawer.refresh(true);

      if (!transaction || transaction.id !== id) {
        return;
      }

      displayPending('drawer');
      refreshNow();
      runWholesale(id);
    } catch (error) {
      console.warn('WWFS: Background cart refresh failed.', error);
      finishTransaction(id);
    }
  }

  function outsideCart(element) {
    return !(
      element &&
      element.closest &&
      element.closest(SELECTORS.drawer + ', ' + SELECTORS.cartPage)
    );
  }

  function handleCartSuccess(event) {
    if (outsideCart(event.target)) {
      var id = beginTransaction('drawer');

      window.clearTimeout(outsideAddTimer);
      outsideAddTimer = window.setTimeout(function () {
        refreshClosedDrawer(id);
      }, OUTSIDE_ADD_RENDER_WAIT);

      return;
    }

    var scope = scopeFor(event.target);
    var internalId = transaction && transaction.scope === scope
      ? transaction.id
      : beginTransaction(scope);

    /*
     * cart-items dispatches this event only after its new sections are in
     * the DOM, so Wholesale can safely run immediately.
     */
    runWholesale(internalId);
  }

  function handleInternalIntent(event) {
    var target = event.target;

    if (
      !target ||
      !target.closest ||
      !target.closest(SELECTORS.drawer + ', ' + SELECTORS.cartPage)
    ) {
      return;
    }

    var isRemoveClick =
      event.type === 'click' &&
      target.closest('.js-remove-item');
    var isQuantityChange =
      event.type === 'change' &&
      target.closest('quantity-input, [name="updates[]"]');

    if (isRemoveClick || isQuantityChange) {
      beginTransaction(scopeFor(target));
    }
  }

  function handleCartError() {
    window.clearTimeout(outsideAddTimer);
    window.clearTimeout(wholesaleReadyTimer);

    if (transaction) {
      finishTransaction(transaction.id);
    } else {
      refresh();
    }
  }

  function relevantMutation(mutation) {
    var target = mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target.parentElement;

    return Boolean(
      target &&
      target.nodeType === 1 &&
      target.closest &&
      target.closest(
        SELECTORS.drawer + ', ' +
        SELECTORS.cartPage + ', ' +
        SELECTORS.summary
      )
    );
  }

  var cartRootObservers = new WeakMap();

  function findCartRoots(root) {
    if (!root) {
      return [];
    }

    var cartRoots = [];

    if (
      root.nodeType === 1 &&
      root.matches(SELECTORS.drawer + ', ' + SELECTORS.cartPage)
    ) {
      cartRoots.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      cartRoots = cartRoots.concat(
        Array.from(
          root.querySelectorAll(
            SELECTORS.drawer + ', ' + SELECTORS.cartPage
          )
        )
      );
    }

    return cartRoots;
  }

  function observeCartRoots(root) {
    var cartRoots = findCartRoots(root);

    cartRoots.forEach(function (cartRoot) {
      if (cartRootObservers.has(cartRoot)) {
        return;
      }

      var rootObserver = new MutationObserver(function (mutations) {
        if (mutations.some(relevantMutation)) {
          refresh();
        }
      });

      cartRootObservers.set(cartRoot, rootObserver);
      rootObserver.observe(cartRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  observeCartRoots(document);

  document.addEventListener('shopify:section:load', function (event) {
    observeCartRoots(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    findCartRoots(event.target).forEach(function (cartRoot) {
      var rootObserver = cartRootObservers.get(cartRoot);

      if (rootObserver) {
        rootObserver.disconnect();
        cartRootObservers.delete(cartRoot);
      }
    });
  });

  document.addEventListener('click', handleInternalIntent, true);
  document.addEventListener('change', handleInternalIntent, true);
  document.addEventListener('on:cart:add', handleCartSuccess);
  document.addEventListener('on:line-item:change', handleCartSuccess);
  document.addEventListener('on:cart:error', handleCartError);
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);

  window.WWFSCartPricing = {
    refresh: refresh,
    refreshNow: refreshNow,
    recalculate: function (scope) {
      var id = beginTransaction(scope || 'drawer');
      runWholesale(id);
    }
  };

  refresh();
})();
